import styled, { css } from 'styled-components';

interface HeaderProps {
  level: number;
}

export const Container = styled.div`
  padding: 20px;
  padding-left: 32px;
  position: relative;
  width: 450px;
  transition: transform 0.2s;
  margin: 10px 0 31px;
  cursor: pointer;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 1024px) {
    width: 400px;
  }

  @media (max-width: 930px) {
    max-width: 370px;
    padding-left: 22px;
  }

  @media (max-width: 540px) {
    max-width: 380px;
  }

  @media (max-width: 420px) {
    max-width: 340px;
  }

  @media (max-width: 380px) {
    max-width: 250px;
  }
`;

export const Header = styled.header<HeaderProps>`
  position: absolute;
  display: flex;

  top: -4px;
  left: 16px;

  p {
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    padding: 0.12rem 0;
    font-size: 0.875rem;
    letter-spacing: 3px;
    font-weight: bold;

    color: #fff;

    width: 104px;
  }

  ${(props) => {
    if (props.level) {
      if (props.level === 1) {
        return css`
          p {
            background: ${({ theme }) => theme.smoothBlue};
          }
        `;
      } else if (props.level === 2) {
        return css`
          p {
            background: ${({ theme }) => theme.purple};
          }
        `;
      } else {
        return css`
          p {
            background: ${({ theme }) => theme.orange};
          }
        `;
      }
    }
  }}

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    span {
      padding: 0 4px;
      color: ${({ theme }) => theme.black};
      font-size: 1rem;
    }

    background: linear-gradient(
      90deg,
      rgba(220, 220, 233, 1) 0%,
      rgba(179, 175, 108, 1) 100%
    );
  }

  @media (max-width: 930px) {
    left: 16px;
  }
`;

export const Content = styled.div`
  box-shadow: 2px 2px 6px 2px rgba(0, 0, 0, 0.2);
  display: flex;
  padding: 14px 8px 14px 0;
  width: 380px;
  height: 200px;
  background: ${({ theme }) => theme.backgroundCard};

  display: flex;
  align-items: center;

  > span {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      height: 150px;
    }
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    min-width: 210px;

    span {
      h1 {
        line-height: 36px;
        font-size: 2.2rem;
        font-weight: 600;
        margin: 0;
        color: ${({ theme }) => theme.text};
      }

      h2 {
        line-height: 25px;
        margin: 0;
        font-weight: 500;
        color: ${({ theme }) => theme.text};

        &:nth-child(2) {
          margin-bottom: 10px;
        }
      }
    }
  }

  @media (max-width: 1024px) {
    width: 330px;
    height: 180px;

    > span {
      img {
        height: 90px;
      }
    }

    div {
      min-width: 190px;

      span {
        h1 {
          font-size: 1.8rem;
        }

        h2 {
          font-size: 1.5rem;
        }
      }
    }
  }

  @media (max-width: 400px) {
    width: 300px;
    height: 150px;

    > span {
      img {
        height: 80px;
      }
    }

    div {
      min-width: 170px;

      span {
        h1 {
          font-size: 1.5rem;
          line-height: 20px;
        }

        h2 {
          font-size: 1.25rem;
          line-height: 22px;
        }
      }
    }
  }

  @media (max-width: 375px) {
    width: 220px;
    height: 130px;

    > span {
      img {
        height: 60px;
      }
    }

    div {
      min-width: 125px;

      span {
        h1 {
          font-size: 1.25rem;
          line-height: 18px;
        }

        h2 {
          font-size: 1rem;
          line-height: 15px;
        }
      }
    }
  }
`;

export const Footer = styled.footer`
  display: flex;
  align-items: center;
  position: absolute;
  right: 36px;
  bottom: -6px;

  button {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    padding: 4px;
    transition: transform 0.2s;

    height: 35px;
    width: 35px;

    svg {
      height: 20px;
      width: 20px;
      margin-bottom: 2px;
    }

    &:first-child {
      background: #6aba76;
      color: #fff;
    }

    &:first-child:hover {
      transform: scale(1.1);
    }

    &:nth-child(2) {
      background: #000;
      color: #fff;
    }

    &:nth-child(2):hover {
      transform: scale(1.1);
    }

    &:last-child {
      background: #000;
      color: #fff;
      border-radius: 0;
      padding: 15px;
      margin-left: 14px;
      margin-bottom: 0px;

      height: 50px;
      width: 50px;

      display: flex;
      align-items: center;
      justify-content: center;
      transform: rotate(-45deg);

      svg {
        transform: rotate(45deg);
      }
    }

    & + button {
      margin-left: 5px;
    }
  }

  @media (max-width: 930px) {
    right: 12px;
  }

  @media (max-width: 540px) {
    right: 22px;
  }

  @media (max-width: 420px) {
    right: 5px;
  }

  @media (max-width: 414px) {
    right: -15px;
  }

  @media (max-width: 395px) {
    right: 12px;
  }

  @media (max-width: 380px) {
    right: 4px;
    bottom: 0px;

    button {
      height: 30px;
      width: 30px;

      svg {
        height: 16px;
        width: 16px;
      }
      &:last-child {
        height: 40px;
        width: 40px;

        svg {
          height: 16px;
          width: 16px;
        }
      }
    }
  }
`;
